import type { QueryOptions } from "@tanstack/react-query"
import type { ExactPartial } from "@wagmi/core/internal"

import { Evaluate, getAddress } from "viem"
import {
  type GetUnitOfAccountPriceErrorType,
  type GetUnitOfAccountPriceParameters,
  type GetUnitOfAccountPriceReturnType,
  getUnitOfAccountPrice,
} from "../actions/getUnitOfAccountPrice"
import type { ExtendedConfig, ScopeKeyParameter } from "../types"
import { filterQueryOptions } from "../utils"

export type GetUnitOfAccountPriceOptions = Evaluate<
  ExactPartial<GetUnitOfAccountPriceParameters> & ScopeKeyParameter
>

export function getUnitOfAccountPriceQueryKey(
  options: GetUnitOfAccountPriceOptions = {},
) {
  const { unitOfAccount, ...parameters } = options
  return [
    "unitOfAccountPrice",
    filterQueryOptions({
      unitOfAccount: unitOfAccount && getAddress(unitOfAccount),
      ...parameters,
    }),
  ] as const
}

export function getUnitOfAccountPriceQueryFn(
  config: ExtendedConfig,
  options: GetUnitOfAccountPriceOptions = {},
) {
  const { ...parameters } = options
  return getUnitOfAccountPrice(config, parameters)
}

export function getUnitOfAccountPriceQueryOptions<
  config extends ExtendedConfig,
>(config: config, options: GetUnitOfAccountPriceOptions) {
  return {
    gcTime: 0,
    queryFn: async ({ queryKey }) => {
      return getUnitOfAccountPriceQueryFn(config, queryKey[1])
    },
    queryKey: getUnitOfAccountPriceQueryKey(options),
  } satisfies QueryOptions<
    GetUnitOfAccountPriceQueryFnData,
    GetUnitOfAccountPriceErrorType,
    GetUnitOfAccountPriceData,
    GetUnitOfAccountPriceQueryKey
  >
}

export type GetUnitOfAccountPriceQueryFnData = GetUnitOfAccountPriceReturnType

export type GetUnitOfAccountPriceData = GetUnitOfAccountPriceQueryFnData

export type GetUnitOfAccountPriceQueryKey = ReturnType<
  typeof getUnitOfAccountPriceQueryKey
>
